import React, { Fragment } from "react";
import { Link } from 'react-router-dom';


const Description = ()=> {

  return (
    <Fragment>
      <div className="description-overlay">
        <h5> Complete your first Apps & Games offer </h5>
        <p> Play a game or install an app and you can get rewards up to <strong>50.000</strong> points for each completed task. </p>
      </div>
        <Link className="btn action btn-primary" to={"/offers"}>Claim Bonus</Link>
    </Fragment>
  );
};

export default Description;
